// extracted by mini-css-extract-plugin
module.exports = {"answer":"question-and-answer_answer__LvOl0","collapse":"question-and-answer_collapse__UHhS_"};